module.exports = __webpack_public_path__ + "img/switzerland-ischemic-heart-disease-female.d7c1c85c.png";